import React, { Component } from 'react'
import _ from 'lodash'

const debounceTime = 300

export default (WrappedComponent) => {

    return class extends Component {

        handleSearch = _.debounce((value) => {
            if (this.props.hasOwnProperty('onSearch')) {
                this.props.onSearch(value)
            }
        }, this.props.hasOwnProperty('delayTime') ? this.props.delayTime : debounceTime)

        render() {
            return <WrappedComponent handleSearch={this.handleSearch} {...this.props} />
        }
    }
}


// WEBPACK FOOTER //
// ./src/hocs/withHandleSearch.js